import React from 'react';
import { withRouter } from 'react-router-dom';

import API, {handleError} from 'utils/xhr';
// import ReactTooltip from 'react-tooltip';
import ReactHelmet from 'react-helmet';

import ContentLayout from 'component/page/content';
import { LoaderRipple } from 'component/loader';

import './slider.css';


class DisplayBasicInfo extends React.Component {
  state = {
    user_data: null,
    user_post: {},
    modified: false,
  }

  componentDidMount(){
    const url = '/users/me';
    API.get(url).then(response =>{
      const state = this.state;
      state.user_data = response.data.data;

      if (state.user_data.user){
        state.user_post = {
          name: state.user_data.user.nickname,
          email: state.user_data.user.email,
        }  
      }
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history);
    })
  }

  onChange(e) {
    const state = this.state;
    state.user_post[e.target.name] = e.target.value;
    state.modified = true;
    this.setState(state);
  }

  onSave() {
    const url = '/users/me';
    const data = this.state.user_post;
    API.post(url, data).then(response => {
      const state = this.state;
      state.modified = false;
      this.setState(state);
    }, (error) => {
      alert("Something went wrong! Unable to update.")
      handleError(error, this.props.history);
    });
  }

  render (){

    if (this.state.user_data === null){
      return (
        <LoaderRipple fetching_data={true} />
      )
    }

    const {user, user_social} = this.state.user_data;

    return (
      <div className="card">
        <div className="card-header">BASIC information</div>
        <div className="card-body">

          <div className="row my-2">
            <label className="col-sm-4 text-black-8">ID:</label>
            <label className="strong col-sm-8">{user.xid}</label>
          </div>

          <div className="row my-2">
            <label className="col-sm-4 text-black-8">Singup Date:</label>
            <label className="strong col-sm-8">{new Date(user.inserted_at).toLocaleString()}</label>
          </div>

          <div className="row my-2">
            <label className="col-sm-4 text-black-8">Name:</label>
            <input className="strong form-control col-sm-7" name="name" value={this.state.user_post.name} onChange={this.onChange.bind(this)} />
          </div>

          <div className="row my-2">
            <label className="col-sm-4 text-black-8">E-Mail:</label>
            <input className="strong form-control col-sm-7" name="email" value={this.state.user_post.email} onChange={this.onChange.bind(this)} />
          </div>

          <div className="row my-2">
            <label className="col-sm-4"></label>
            <button onClick={this.onSave.bind(this)} className={"col-sm-8 btn btn-sm btn-rounded btn-success" + (this.state.modified? ' ': ' d-none')}><i className="fa fa-edit mr-2"></i>Save</button>
          </div>

          
          <hr className="my-3"/>
          
          <h5>Logins:</h5>
          {user_social.map(function(item, idx){
            return (
              <div key={"_" + idx} className="">
                <div className="row">
                  <label className="col-sm-4 text-black-8"><i className={`fab fa-${item.social_network} mr-2`}></i></label>
                  <label className="strong col-sm-8">{item.social_id}</label>
                </div>
              </div>
            )
          })}

        </div>
      </div>
    )
  }
}

class ProfileSection extends React.Component {

  state = {
    public_key: 'pk_test_JYxeHTkYTq2iXAP9YVBFo6hv',
    tier: null,
    tier_data: null,
    stats: null,
    toggle:{
      yearly: true,
    },
    loader: {
      starter: false,
    }
  }

  componentDidMount(){
    
    const tier_url = '/payments/tiers/me';
    API.get(tier_url).then(response =>{
      const state = this.state;
      state.tier = response.data.data.tier;
      state.tier_data = response.data.data.tier_data;
      this.setState(state);
    },(error) => {
      handleError(error, this.props.history, window.location.pathname);
    })
    
    const stats_url = '/sites/stats';
    API.get(stats_url).then(response =>{
      const state = this.state;
      state.stats = response.data.data;
      this.setState(state)
      
    },(error) => {
      handleError(error, this.props.history, window.location.pathname);
    })

  }

  handleToggleYearly = () => {
    const state = this.state;
    state.toggle.yearly = !state.toggle.yearly;
    this.setState(state);
  }

  handleUpgradeStarter(){
    const url = '/payments/stripe/checkout_session';
    const data = {
      selected_plan_key: this.state.toggle.yearly? 'starter-yearly': 'starter-monthly',
    }
    const public_key = this.state.public_key;

    const state = this.state;
    state.loader.starter = true;
    this.setState(state);

    API.post(url, data).then(response =>{
      const checkout_session_id = response.data.data.checkout_session_id;

      const stripe = window.Stripe(public_key);
      stripe.redirectToCheckout({
        sessionId: checkout_session_id
      }).then(function(result) {
        console.log("error");
        console.log(result.error.message);
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
        const state = this.state;
        state.loader.starter = false;
        this.setState(state);
      }).catch(function(err) {
        console.log(err);
        const state = this.state;
        state.loader.starter = false;
        this.setState(state);
      });
      
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }
  handleUnsubscribe (){
    const url = '/payments/stripe/unsubscribe';
    const data = {}
    API.post(url, data).then(response =>{
      // TODO: fix this reload!
      window.location.reload();
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  render (){
    // const is_yearly = this.state.toggle.yearly;

    // const stripeApiKey = this.state.public_key;
    // const name = "DivShow by ByteBeacon";

    // const starter_plan = {
    //   false: {
    //     amount: 1000,
    //     label: "$10 / month",
    //     description: "Monthly subscription",
    //   },
    //   true: {
    //     amount: 10000,
    //     label: "$100 / year -- 2 month free",
    //     description: "Yearly subscription",
    //   },
    // }[is_yearly]

    return(
      <div>
        <div className="row">

          <ReactHelmet>
            <script src="https://js.stripe.com/v3/"></script>
          </ReactHelmet>

        <div className="col-lg-6 col-md-12">
            <div className="m-1">
              <DisplayBasicInfo />
            </div>
          </div>

{/*           
          <div className="col-lg-6">
            <div className="card m-1">
              <div className="card-header">MOCK: USER information</div>
              <div className="card-body">

                <div className="row"><label className="col-sm-4">Name:</label><label className="strong col-sm-8">Catalystic</label></div>
                <div className="row"><label className="col-sm-4">Phone:</label><label className="strong col-sm-8">+91 98765 09876</label></div>
                <div className="row"><label className="col-sm-4">Company:</label><label className="strong col-sm-8">RYSA Inc</label></div>
                <div className="row"><label className="col-sm-4">Website:</label><label className="strong col-sm-8">https://rysa.com</label></div>
                <div className="row"><label className="col-sm-4">Timezone:</label><label className="strong col-sm-8">1234512345</label></div>
              </div>
            </div>
          </div> */}

          
          <div className="col-lg-6 col-md-12">
            <div className="card m-1">
              <div className="card-header">USAGE statistics</div>
              <div className="card-body">
                <div className="row"><label className="col-sm-3 text-black-8">Total sites:</label><label className="strong col-sm-9">{(this.state.stats !== null)? this.state.stats.site_count: 0}</label></div>
                <div className="row"><label className="col-sm-3 text-black-8">Total shows:</label><label className="strong col-sm-9">{(this.state.stats !== null)? this.state.stats.show_count: 0}</label></div>
                
                {/* <hr className="my-3"/> */}

                {/* <div className="card-body">

                  <div className="row strong mb-0 pb-0">
                    <label className="col-sm-3 text-black-8">Tier</label>
                    <label className="col-sm-2 text-black-8">Purchased</label>
                    <label className="col-sm-2 text-black-8">Created</label>
                    <label className="strong col-sm-5">
                    </label>
                  </div>

                  <hr className="my-2"/>

                  <div className="row ">
                    <label className="col-sm-3"><Link to="/pricing">Free</Link></label>
                    <label className="col-sm-2">{"Unlimited"}</label>
                    <label className="col-sm-2">{(this.state.stats !== null)? this.state.stats.show_distribution.free: 0}</label>
                    <label className="col-sm-5"></label>
                  </div>

                  <hr className="my-2"/>

                  <div className="row ">
                    <label className="col-sm-3"><Link to="/pricing">Starter</Link></label>
                    <label className="col-sm-2">{"0"}</label>
                    <label className="col-sm-2">{(this.state.stats !== null)? this.state.stats.show_distribution.starter || 0: 0}</label>
                    <label className="col-sm-5">
                      <p className="text-muted">Min 20 show purchase</p>
                    {(this.state.tier === null || this.state.tier.name === 'free')? (
                      <div className="form-group row">
                        <div className="col-sm-3">
                        
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={this.state.toggle.yearly}
                              onChange={this.handleToggleYearly}
                            />
                            <span className={(this.state.toggle.yearly? 'bg-success': 'bg-warning') + " slider btn-rounded"}></span>
                          </label>
                        
                        </div>
                        <div className="col-sm-9 col-form-label text-muted">{this.state.toggle.yearly? 'Yearly Plan': 'Monthly Plan'}</div>
                      </div>
                    ): ('')}

                    {(this.state.tier === null || this.state.tier.name === 'free')? (
                      <button onClick={this.handleUpgradeStarter.bind(this)} className={"text-white btn btn-block btn-rounded " + (is_yearly? 'btn-success': 'btn-warning')}> <i className="fa fa-credit-card mr-2"></i> {starter_plan.label}</button>
                    ): (
                      (this.state.tier_data.status === "unsubscribe_at_period_end")? (
                        <div>
                          <label className={"text-danger"}><i className="fa fa-check mr-2"></i>Unsubscribed .. Billing stops in the next cycle</label>
                          <button onClick={this.handleUpgradeStarter.bind(this)} className={"text-white btn btn-rounded btn-block " + (is_yearly? 'btn-success': 'btn-warning')}> <i className="fa fa-credit-card mr-2"></i> {starter_plan.label}</button>
                        </div>
                      ): (
                        <div className="">
                          <label className={"text-white btn-block btn btn-secondary btn-rounded disabled"}><i className="fa fa-check mr-2"></i>Subscribed</label>
                          <a href="/" onClick={this.handleUnsubscribe.bind(this)} className="mx-2 link text-muted">Unsubscribe</a>
                        </div>
                      )
                    )}
                      <LoaderRipple fetching_data={this.state.loader.starter} />
                    </label>
                  </div>

                  <hr className="my-2"/>
                  
                  <div className="row ">
                    <label className="col-sm-3"><Link to="/pricing">Enterprise</Link></label>
                    <label className="col-sm-2">0</label>
                    <label className="col-sm-2">0</label>
                    <label className="col-sm-5">
                      <a className="btn btn-block btn-info btn-rounded" href="mailto:info@bytebeacon.com">Contact us</a>
                    </label>
                  </div>
                  
                </div> */}

              </div>
            </div>
          </div>
         

        </div>

      </div>
    )
  }
}


class Page extends React.Component {

  render () {
    return (
      <ContentLayout id="account-page">
        <ProfileSection />
      </ContentLayout>
    )
  }
}

export default withRouter(Page);
